import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PasswordMask from 'components/components/common/PasswordMask';
import axios from 'components/AppRequest';
import CustomerBasicDataValidation from 'components/components/auth/utils/CustomerBasicDataValidation';
import { Error } from 'components/common/Form.js';
import CommunicateBox from 'components/components/common/CommunicateBox';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import {
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import { connect } from 'react-redux';
import mergeErrors from 'components/helpers/mergeErrors';
import TransHelper from 'components/common/translations/TransHelper';

function SampleEyeShow() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye']}
      title="Show"
    />
  );
}

function SampleEyeHide() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye-slash']}
      title="Hide"
    />
  );
}

class ProfileResetPassword extends Component {
  state = {
    oldPassword: '',
    newPassword: '',
    errors: {},
    isLoading: false
  }

  handleChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  validateFields = () => {
    this.setState({
      errors: {},
      isLoading: true
    });
    const { oldPassword, newPassword } = this.state;
    var customerValidation = new CustomerBasicDataValidation(false,this.props.locale);
    var isValidOldPassword = customerValidation.isValidPassword(oldPassword);
    var isValidNewPassword = customerValidation.isValidPassword(newPassword);
    if (isValidOldPassword && isValidNewPassword) {
      return true;
    } else {
      this.setState({
        errors: {
          oldPassword: customerValidation.validationPassword(oldPassword),
          newPassword: customerValidation.validationPassword(newPassword),
        }
      });
      return false;
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    const { oldPassword, newPassword } = this.state;
    var isValid = this.validateFields();
    var params = { oldPassword, newPassword };
    if (isValid) {
      axios.post('/pwa/customer/change-password', params)
        .then(response => {
          this.props.createSuccessNotification({
            message: this.trans('success')
          });
          this.setState(
            {
              oldPassword: '',
              newPassword: '',
              isLoading: false
            }
          );
        })
        .catch(err => {
          console.log('err', err)
          var mergedErrors = mergeErrors(err.response.data.errors);
          this.props.createErrorNotification({
            title: this.trans('error'),
            message: mergedErrors
          })
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        isLoading: false
      })
    }
  }

  trans = (key,prefix = "content.common") => {
    return TransHelper.translate(this.props.locale, prefix + "." + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.profileResetPassword');
  }

  render() {
    const { errors, oldPassword, newPassword, isLoading } = this.state;
    return (
      <form onSubmit={this.submitForm}>
        <fieldset>
          <legend className="visuallyhidden">Reset password form</legend>
          <ul className="list-fields list-none" style={{ marginBottom: '47px' }}>
            <li className="list-fields__item">
              <label htmlFor="oldPassword">{this.trans('inputs.oldPassword')}</label>
              <PasswordMask
                id="oldPassword"
                name="oldPassword"
                value={oldPassword}
                onChange={this.handleChangeInput}
                showButtonContent={<SampleEyeShow />}
                hideButtonContent={<SampleEyeHide />}
                buttonClassName="button--toggle"
                className="button-toggle-wrap"
              />
              <Error error={errors.oldPassword} />
            </li>

            <li className="list-fields__item">
              <label htmlFor="newPassword">{this.trans('inputs.newPassword')}</label>
              <PasswordMask
                id="newPassword"
                name="newPassword"
                value={newPassword}
                onChange={this.handleChangeInput}
                showButtonContent={<SampleEyeShow />}
                hideButtonContent={<SampleEyeHide />}
                buttonClassName="button--toggle"
                className="button-toggle-wrap"
              />
              <Error error={errors.newPassword} />
            </li>
          </ul>

          {isLoading
            ?
            <LoadingSpinner className="button button--expand" />
            :
            <button className="button button--expand">{this.trans('save')}</button>
          }
        </fieldset>
      </form>
    );
  }
}

export default connect(
  null,
  { createSuccessNotification, createErrorNotification }
)(ProfileResetPassword);
